/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { DriveHistoryExcelService } from './services/DriveHistoryExcelService';
import { DrivingHistoryService } from './services/DrivingHistoryService';
import { EvBatteryService } from './services/EvBatteryService';
import { SafeDrivingService } from './services/SafeDrivingService';
import { TermsContentsService } from './services/TermsContentsService';
import { TireService } from './services/TireService';
import { TripTagsService } from './services/TripTagsService';
import { UbiService } from './services/UbiService';
import { VehicleService } from './services/VehicleService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class DiApiEu {
  public readonly driveHistoryExcel: DriveHistoryExcelService;
  public readonly drivingHistory: DrivingHistoryService;
  public readonly evBattery: EvBatteryService;
  public readonly safeDriving: SafeDrivingService;
  public readonly termsContents: TermsContentsService;
  public readonly tire: TireService;
  public readonly tripTags: TripTagsService;
  public readonly ubi: UbiService;
  public readonly vehicle: VehicleService;
  public readonly request: BaseHttpRequest;
  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'https://stg-di-api-eu.kia.com',
      VERSION: config?.VERSION ?? '1.1.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.driveHistoryExcel = new DriveHistoryExcelService(this.request);
    this.drivingHistory = new DrivingHistoryService(this.request);
    this.evBattery = new EvBatteryService(this.request);
    this.safeDriving = new SafeDrivingService(this.request);
    this.termsContents = new TermsContentsService(this.request);
    this.tire = new TireService(this.request);
    this.tripTags = new TripTagsService(this.request);
    this.ubi = new UbiService(this.request);
    this.vehicle = new VehicleService(this.request);
  }
}

